export const CATEGORY_OPTIONS = [
  "Electronics",
  "Books",
  "Supplies",
  "Appliances",
  "Clothing",
  "Decor",
  "Furniture",
  "Miscellaneous"
];